import { LabeledInput as GammaLabeledInput } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type LabeledInputProps = React.ComponentProps<typeof GammaLabeledInput>

type Props = Omit<LabeledInputProps, 'selectValue' | 'missingLabel'> & {
  missingLabel?: string
}

const LabeledInput: React.FC<Props> = ({ missingLabel, ...props }) => (
  <GammaLabeledInput
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
  />
)

export default LabeledInput
